<script lang="ts">
	let { children, borderStyle = 'solid', hasBackground = true, class: className = '' } = $props();
</script>

<div
	class="rounded-lg border-2 border-[{borderStyle}] border-gray-300 py-4 {hasBackground
		? 'bg-gray-200'
		: ''} px-4 sm:py-4 dark:border-gray-700 {hasBackground
		? 'dark:bg-gray-900'
		: ''} shadow-lg {className}"
>
	{@render children()}
</div>
